
export default function latLngDecimalToStandard(num, type) {
  num = Number(num) || 0;
  let s = type === 'lat' ?
    (num >= 0 ? 'N' : 'S') :
    (num >= 0 ? 'E' : 'W');
  num = Math.abs(num);
  let r1 = Math.floor(num);
  let r2 = Math.floor((num - r1) * 60);
  let r3 = ((num - r1 - r2/60) * 3600).toFixed(3);


  return `${r1}°${r2}'${r3}"${s}`;
}



// WEBPACK FOOTER //
// ./src/components/Poi2/latLngDecimalToStandard.js